import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { WarningCircle, XmarkCircle } from 'iconoir-react'
import { businessDaysDiff } from 'lib/businessDays'

export function PMSIntegrationCell({
  isIntegrated,
  lastPmsSyncDate,
}: {
  isIntegrated: boolean
  lastPmsSyncDate?: Date
}) {
  return (
    <span>
      {isIntegrated ? (
        (() => {
          if (lastPmsSyncDate && Math.abs(businessDaysDiff(new Date(lastPmsSyncDate), new Date())) <= 2) {
            return <CheckCircleIcon className="h-5 w-5 fill-current text-blue-400" />
          } else {
            return <WarningCircle className="m-0 h-5 w-5 rounded-full bg-surface bg-opacity-40 p-0 text-amber-900" />
          }
        })()
      ) : (
        <XmarkCircle className="h-5 w-5 text-red-400" />
      )}
    </span>
  )
}
